import React from "react";
import { type DetailedPaymentPrefUnionObjectType } from "../../common/types";
import { BasePaymentPrefDisplay } from "../BasePaymentPrefDisplay";
import { PaymentPrefDetails } from "../PaymentPrefDetails";
import { PaymentPrefVisibleFields } from "../PaymentPrefDetails/types";
import { isRevealablePaymentPref } from "./utils";

export type PreviewPaymentPrefDisplayProps = {
  /** Payment preference data to preview */
  paymentPref: DetailedPaymentPrefUnionObjectType;
  /** Whether details should be expanded by default */
  defaultExpanded?: boolean;
  /** Optional accessory content (string or component) displayed between title and reveal button */
  accessory?: React.ReactNode;
  /** Specify which fields to show. If omitted, all fields are shown by default. */
  visibleFields?: PaymentPrefVisibleFields;
};

/**
 * Component for previewing payment preference information with configurable field visibility.
 *
 * This component displays payment preferences in preview mode, automatically determining
 * whether details can be revealed based on the payment preference type. It supports
 * displaying accessory content and controlling which fields are visible.
 */
export const PreviewPaymentPrefDisplay: React.FC<PreviewPaymentPrefDisplayProps> = ({
  paymentPref,
  defaultExpanded,
  accessory,
  visibleFields,
}: PreviewPaymentPrefDisplayProps) => {
  return (
    <BasePaymentPrefDisplay
      paymentPref={paymentPref}
      displayRevealDetails={isRevealablePaymentPref(paymentPref)}
      renderDetails={() => (
        <PaymentPrefDetails paymentPrefFull={paymentPref} visibleFields={visibleFields} />
      )}
      defaultExpanded={defaultExpanded}
      accessory={accessory}
    />
  );
};
